import type { FaireProductEntity } from "../../entity_types/product";

export const bath_2: FaireProductEntity = {
  token: "bath-2",
  type: "product",
  name: "Eucalyptus Body Wash",
  brandName: "Pure Soap Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/6fe22033c0a43e1151fa29444e8b1f602112ed24e1a870f22e5ea1be018775c3.webp",
  priceDollars: 12,
  msrpDollars: 20,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_beauty-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
